var exports = {
  "JC": "UserProfilePopout.module__role___X3V3Nn",
  "s$": "UserProfilePopout.module__roleRemoveIcon___X3V3Nn",
  "Bx": "UserProfilePopout.module__iconSmall___X3V3Nn",
  "bc": "UserProfilePopout.module__profileCustomStatus___X3V3Nn",
  "CQ": "UserProfilePopout.module__profileCustomStatusText___X3V3Nn",
  "ZB": "UserProfilePopout.module__profileDisplayName___X3V3Nn",
  "yn": "UserProfilePopout.module__profileDataWarning___X3V3Nn",
  "zF": "UserProfilePopout.module__profilePopoutCard___X3V3Nn",
};

module.exports = exports;
